import IAppeal from "@/interfaces/appeal";
import gql from "@/repo/apolloClient";
import RestAPIClient from "@/repo/restApi";
import { makeAutoObservable, runInAction } from "mobx";

export default class AppealStore {
  restApi: RestAPIClient<unknown>;
  private selectAppeal: IAppeal | null = null;
  private myAppeal?: IAppeal[];

  constructor() {
    makeAutoObservable(this);
    this.restApi = new RestAPIClient("cryptoMarketPlace");
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleMyAppealsUpdate = (response: any) => {
    runInAction(() => {
      this.myAppeal = response.data.appeals ?? [];
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleSelectedAppealUpdate = (response: any) => {
    runInAction(() => {
      this.selectAppeal = response.data.appeals[0] ?? null;
    });
  };
  public subscribeToMyAppeals = async () => {
    const query = `
    subscription getMyAppeals{
        appeals {
          id
          order_id
          status
          created_at
          created_by
          appeal_to
          appeal_type
          appeal_reason
          admin_id
        }
      }
    `;

    const subscription = (await gql.Subscribe(query)).subscribe({
      next: this.handleMyAppealsUpdate,
      error: (error) => console.error("Error fetching my appeals: ", error),
    });

    return () => subscription.unsubscribe();
  };
  public subscribeToAppealById = async (appeal_id: string) => {
    const query = `
    subscription getAppealById{
        appeals(where: {id: {_eq: "${appeal_id}"}}) {
          id
          order_id
          status
          created_at
          created_by
          appeal_to
          appeal_type
          appeal_reason
          admin_id
          user {
            username
            firstname
            lastname
            phone_number
          }
          userByAppealTo {
            username
            firstname
            lastname
            phone_number
          }
        }
      }
    `;

    const subscription = (await gql.Subscribe(query)).subscribe({
      next: this.handleSelectedAppealUpdate,
      error: (error) => console.error("Error fetching appeal by id: ", error),
    });

    return () => {
      subscription.unsubscribe();
      runInAction(() => {
        this.selectAppeal = null;
      });
    };
  };
  public subscribeToAppealByOrder = async (
    order_id: string,
    user_id: string,
  ) => {
    const query = `
    subscription getAppealByOrder{
        appeals (where: { _and: [{ order_id: { _eq: "${order_id}" } }, { created_by: { _eq: "${user_id}" } }] }) {
          id
          order_id
          status
          created_at
          created_by
          appeal_to
          appeal_type
          appeal_reason
          admin_id
        }
      }
    `;

    const subscription = (await gql.Subscribe(query)).subscribe({
      next: this.handleSelectedAppealUpdate,
      error: (error) =>
        console.error("Error fetching appeal by order id: ", error),
    });

    return () => {
      subscription.unsubscribe();
      runInAction(() => {
        this.selectAppeal = null;
      });
    };
  };
  public createAppeal = async (request: {
    contract_order_id: string;
    appeal_to: string;
    appeal_reason: string;
    appeal_type: "BUYER" | "SELLER";
    nonce: string;
    requestor_address: string;
    signature: string;
  }): Promise<string | null> => {
    const response = await this.restApi.post({
      method: "createAppeal",
      request,
    });
    if (response.data) {
      return response.data.data;
    }
    return null;
  };
  public close = async (appeal_id: string): Promise<string | null> => {
    const mutation = `
    mutation MyMutation($appeal_id: uuid!) {
      update_appeals_by_pk(pk_columns: {id: $appeal_id}, _set: {status: "CLOSED"}) {
        id
      }
    }    
    `;
    const result = await gql.Mutation(mutation, {
      appeal_id,
    });
    return (result.data.update_appeals_by_pk.id as string) ?? null;
  };

  public get myAppeals() {
    return this.myAppeal;
  }
  public get selectedAppeal() {
    return this.selectAppeal;
  }
}
